module.exports = __webpack_public_path__ + "img/btn_register.f9b4ce3c.png";